import { useMutation } from "react-query";
import { t } from "@/i18n-js/instance";
import { spaceApi } from "@circle-react/api/spaceApi";
import { usePunditUserContext } from "@circle-react/contexts";
import type { Space } from "@circle-react/types";
import { useToast } from "@circle-react-uikit/ToastV2";

interface UseChatTranscriptProps {
  space: Space;
}

export const useChatTranscript = ({ space }: UseChatTranscriptProps) => {
  const { error, success } = useToast();
  const { currentUser } = usePunditUserContext();
  const chatTranscriptMutation = useMutation(
    (timeFrame: string) =>
      spaceApi.chatTranscript({
        id: space?.id,
        params: { time_frame: timeFrame },
      }),
    {
      onSuccess: () => {
        success(
          t("settings.spaces.chat_export.success", {
            name: space?.name,
            email: currentUser?.email,
          }),
        );
      },
      onError: () => error(t("settings.spaces.chat_export.error")),
    },
  );

  return {
    mutateChatTranscript: chatTranscriptMutation.mutate,
  };
};
